import axios from "axios";

export const getSyncCategoriesApi = async () => {
  try {
    const response = await axios.get(
      "https://addison-api.azurewebsites.net/Api/Addison/syncCategories",
      { timeout: 15000, responseType: "text" }
    );
    let raw = response.data;
    // Response is a JSON array wrapped in an XML <string> element
    const match = raw.match(/<string[^>]*>([\s\S]*)<\/string>/);
    if (match) {
      raw = match[1];
    }
    const categories = JSON.parse(raw);
    console.log("Fetched categories:", categories);
    return { success: true, payload: categories };
  } catch (e) {
    return { success: false, payload: [], error: e };
  }
};

export const getMethodologyReminder = async (brand_id, size_nm) => {
  try {
    const response = await axios.get(`https://addison-api.azurewebsites.net/api/addison/getMethodologyReminder?brand_i=${brand_id}&size_nm="${size_nm}"`, {
      timeout: 5000
    })
    return { success: true, payload: response };
  } catch (e) {
    return { success: false, payload: [], error: e };
  }
};
